import React, { useState } from "react";
import {
  MenuItem,
  Select,
  SelectChangeEvent,
  SxProps,
  Tooltip,
  Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { COLOR_MAP } from "../../../constants/ColorNames";

interface IProps {
  value: string;
  menuItems: { label: string; value: string; Icon?: JSX.Element }[];
  handleChange: (newValue: string) => void;
  renderValue: (value: string) => React.ReactNode;
  placeholder?: string;
  label?: string;
  sx?: SxProps;
  disabled?: boolean;
  showDisabled?: boolean;
  showDisabledMsg?: boolean;
  disabledMsg?: string;
  handleClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  isDisabled?:boolean
}

const SelectWrapper: React.FC<IProps> = ({
  value,
  menuItems,
  handleChange,
  renderValue,
  sx,
  placeholder,
  label,
  disabled,
  showDisabled,
  showDisabledMsg,
  disabledMsg,
  handleClick,
  isDisabled = false
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    if (!disabled) {
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeOption = (event: SelectChangeEvent) => {
    const value = event.target.value;
    if (value) {
      handleChange(value);
    }
  };

  return (
    <Tooltip
      title={
        showDisabledMsg ? (
          <Typography sx={{ fontSize: "14px" }}>{disabledMsg}</Typography>
        ) : (
          ""
        )
      }
    >
      <Select
        value={value}
        onChange={handleChangeOption}
        open={open}
        {...(!!handleClick && {
          onClick: (e) => handleClick(e),
        })}
        onOpen={handleOpen}
        onClose={handleClose}
        label={label || ""}
        disabled={showDisabled || isDisabled}
        sx={{
          ...sx,
          "& .MuiSelect-select": {
            padding: "0px !important",
            ...(showDisabledMsg && {
              cursor: "not-allowed",
            }),
          },
          "&.Mui-disabled":{
                    backgroundColor:'#F6F6F7',
                },
          ...(showDisabledMsg && {
             backgroundColor: COLOR_MAP.LIGHT_GREY2
          }),
        }}
        renderValue={renderValue}
        IconComponent={(props) =>
          open ? (
            <KeyboardArrowUpIcon
              {...props}
              sx={{ fontSize: 22, minWidth: "unset" }}
            />
          ) : (
            <KeyboardArrowDownIcon
              {...props}
              sx={{ fontSize: 22, minWidth: "unset" }}
            />
          )
        }
      >
        <MenuItem
          value="none"
          sx={{
            textTransform: "capitalize",
            padding: "1.2rem 0.8rem !important",
            display: "none",
          }}
          disabled
        >
          {placeholder}
        </MenuItem>
        {menuItems?.map(({ label, value, Icon }) => (
          <MenuItem
            key={label}
            value={value}
            sx={{
              textTransform: "capitalize",
              padding: "1.2rem 0.8rem !important",
              "&.Mui-selected": {
                backgroundColor: "transparent",
              },
            }}
            disableRipple
          >
            {!!Icon && Icon}
            {label}
          </MenuItem>
        ))}
      </Select>
    </Tooltip>
  );
};

export default SelectWrapper;
